<template>
  <section>
    <h1 class="text-h3 mb-4">
      UI Core
    </h1>
    <p class="mb-8">
      A standard UI development tool for iStaging front-end projects.<br>
      Since Jan, 2022.
    </p>
    <h2 class="text-h4 mb-4">
      Development
    </h2>
    <h3 class="text-h5 mb-2">
      Tech Stack
    </h3>
    <ul class="mb-4">
      <li>
        <a
          href="https://cli.vuejs.org/guide/"
          target="_blank"
          rel="noopener noreferrer"
        >Vue CLI</a>
      </li>
      <li>
        <a
          href="https://vuejs.org/v2/guide/"
          target="_blank"
          rel="noopener noreferrer"
        >Vue 2</a>
      </li>
      <li>
        <a
          href="https://vuetifyjs.com/introduction/why-vuetify/"
          target="_blank"
          rel="noopener noreferrer"
        >Vuetify 2</a>
      </li>
    </ul>
    <v-alert
      class="mb-4"
      type="info"
      outlined
      text
    >
      All refactored front-end projects will use Vue 3 in the future, this project is currently developing with Vue 2, but will be migrated to Vue 3 after Vuetify 3 releases.
    </v-alert>
    <h3 class="text-h5 mb-2">
      Future Tech Stack
    </h3>
    <ul class="mb-4">
      <li>
        <a
          href="https://vitejs.dev"
          target="_blank"
          rel="noopener noreferrer"
        >Vite</a>
      </li>
      <li>
        <a
          href="https://v3.vuejs.org"
          target="_blank"
          rel="noopener noreferrer"
        >Vue 3</a>
      </li>
      <li>
        <a
          href="https://next.vuetifyjs.com"
          target="_blank"
          rel="noopener noreferrer"
        >Vuetify 3</a>
      </li>
    </ul>
    <h3 class="text-h5 mb-2">
      Coding Standards
    </h3>
    <h4 class="text-h6 mb-2">
      ESLint
    </h4>
    <ul class="mb-4">
      <li>
        <a
          href="https://standardjs.com/rules.html"
          target="_blank"
          rel="noopener noreferrer"
        >standard</a>
      </li>
      <li>
        <a
          href="https://eslint.vuejs.org/rules/"
          target="_blank"
          rel="noopener noreferrer"
        >vue/recommended</a>
      </li>
    </ul>
    <h4 class="text-h6 mb-2">
      Stylelint
    </h4>
    <ul class="mb-4">
      <li>
        <a
          href="https://github.com/stylelint-scss/stylelint-config-standard-scss"
          target="_blank"
          rel="noopener noreferrer"
        >standard-scss</a>
      </li>
      <li>
        <a
          href="https://github.com/ota-meshi/stylelint-config-recommended-vue"
          target="_blank"
          rel="noopener noreferrer"
        >recommended-vue</a>
      </li>
      <li>
        <a
          href="https://github.com/stormwarning/stylelint-config-recess-order"
          target="_blank"
          rel="noopener noreferrer"
        >recess-order</a>
      </li>
    </ul>
    <h3 class="text-h5 mb-2">
      UI Guideline
    </h3>
    <a
      href="https://www.figma.com/file/jDb0CyilaHT2kXkxLpUu2w/UI-Guideline-of-2D-VR-Maker?node-id=70%3A447"
      target="_blank"
      rel="noopener noreferrer"
    >UI Guideline of 2D VR Maker</a>
  </section>
</template>

<script>
export default {
  name: 'IntroductionHome',
  components: {},
  props: {},
  data: () => ({}),
  computed: {},
  watch: {},
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>
